import { render, staticRenderFns } from "./job-report-area-browser.component.vue?vue&type=template&id=437f8cb6"
import script from "./job-report-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./job-report-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-report-area-browser.component.vue?vue&type=style&index=0&id=437f8cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports